/**
 * Collections List Slider - Swiper initialization
 */

class CollectionsListSlider {
  constructor() {
    this.initSwiper();
  }

  initSwiper() {
    const swiperElements = document.querySelectorAll('[data-swiper-collections]');

    swiperElements.forEach((element) => {
      const section = element.closest('.section-w-collections-list');
      const thumb = section.querySelector('.section-w-collections-list__scrollbar-thumb');

      const swiper = new Swiper(element, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        freeMode: true,
        breakpoints: {
          750: {
            slidesPerView: 5,
            spaceBetween: 18,
            freeMode: false,
          },
        },
      });

      if (thumb) {
        this.updateThumb(swiper, thumb);

        swiper.on('setTranslate', () => {
          this.updateThumb(swiper, thumb);
        });

        swiper.on('resize', () => {
          this.updateThumb(swiper, thumb);
        });
      }
    });
  }

  updateThumb(swiper, thumb) {
    var wrapperWidth = swiper.wrapperEl.scrollWidth;
    var containerWidth = swiper.el.clientWidth;

    if (wrapperWidth <= containerWidth) {
      thumb.style.width = '100%';
      thumb.style.left = '0';
      return;
    }

    var maxTranslate = wrapperWidth - containerWidth;
    var currentTranslate = Math.abs(swiper.translate);
    var progress = Math.min(Math.max(currentTranslate / maxTranslate, 0), 1);

    var ratio = containerWidth / wrapperWidth;
    var thumbWidth = Math.max(ratio * 100, 20);
    var maxLeft = 100 - thumbWidth;
    var left = progress * maxLeft;

    thumb.style.width = thumbWidth + '%';
    thumb.style.left = left + '%';
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new CollectionsListSlider();
  });
} else {
  new CollectionsListSlider();
}

window.CollectionsListSlider = CollectionsListSlider;
